import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import Small from 'UIComponents/elements/Small';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import CertificateButtonWrapper, { CertificateButtonIconContainer } from './CertificateButtonWrapper';
import { EERIE } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CertificateButtonExpired = ({
  expiresAt,
  name,
  onClick,
  description,
  isSelected
}) => {
  return /*#__PURE__*/_jsxs(CertificateButtonWrapper, {
    isSelected: isSelected,
    isexpired: 1,
    onClick: onClick,
    children: [/*#__PURE__*/_jsx(UITooltip, {
      title: description,
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        className: "p-right-4",
        direction: "column",
        children: [name, /*#__PURE__*/_jsx(Small, {
          use: "help",
          weight: "regular",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            className: "cert-button-subtext",
            message: "learningCenter.mostPopularCertificates.expired",
            options: {
              date: /*#__PURE__*/_jsx(FormattedDateTime, {
                format: "L",
                value: expiresAt
              })
            }
          })
        })]
      })
    }), /*#__PURE__*/_jsx(CertificateButtonIconContainer, {
      isexpired: 1,
      children: /*#__PURE__*/_jsx(UITooltip, {
        title: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "learningCenter.mostPopularCertificates.expiredTooltip",
          options: {
            date: /*#__PURE__*/_jsx(FormattedDateTime, {
              format: "L",
              value: expiresAt
            })
          }
        }),
        children: /*#__PURE__*/_jsx(UIIcon, {
          className: "p-top-1",
          color: EERIE,
          name: "info",
          onClick: e => e.stopPropagation(),
          size: 24
        })
      })
    })]
  });
};
export default CertificateButtonExpired;